import store from '@/store'
const buildSearchString = function ({ filter, searchParams, mode }, { sortBy, sortDesc } = {}) {
  let searchString = '?session-id=' + store.getters['auth/getSessionId'] + '&'

  if (typeof filter === 'object' && filter.bounds) {
    searchString += `bbox=${filter.bounds.join(',')}&`
  }

  if (typeof mode !== 'undefined') {
    searchString += `searchMode=${mode}&`
  }

  if (sortBy instanceof Array && sortBy.length > 0) {
    searchString += `sortBy[]=${sortBy[0]}&`
    searchString += `sortDesc[]=${sortDesc[0]}&`
  }

  for (let i = 0; i < searchParams.length; i++) {
    if (i > 0) searchString += '&'

    switch (searchParams[i].type) {
      case 'craft\\fields\\Number':
        if (typeof searchParams[i].value === 'object' && searchParams[i].value !== null) {
          // number range stuff
          searchString += 'search_' + searchParams[i].path + '[]=' + searchParams[i].value.from + '&'
          searchString += 'search_' + searchParams[i].path + '[]=' + searchParams[i].value.to + '&'
          break
        }

        searchString += 'search_' + searchParams[i].path + '[]=' + searchParams[i].value
        break
      case 'craft\\fields\\Categories':
      case 'modules\\raumkarte\\fields\\Categories':
      case 'craft\\fields\\Dropdown':
        if (searchParams[i].value instanceof Array) {
          for (let k = 0; k < searchParams[i].value.length; k++) {
            if (k > 0) searchString += '&'
            searchString += 'search_' + searchParams[i].path + '[]=' + searchParams[i].value[k]
          }
        } else {
          searchString += 'search_' + searchParams[i].path + '[]=' + searchParams[i].value
        }
        break
      default:
        searchString += 'search_' + searchParams[i].path + '[]=' + searchParams[i].value
    }
  }

  return searchString
}

export { buildSearchString }
